export default __webpack_public_path__ + "static/italy-11bad7d46a135210088a7bc5a113853b.jpg";